import { useContext } from "@nuxtjs/composition-api";
import PROFESSION_TASK_PROFESSIONALS from "./professionTaskProfessionals.graphql";

export function useFetchProfessionTaskProfessionals(context) {
  const { $query } = context || useContext();

  return async ({ professionTaskSeoName, citySeoName, page = 1, pageSize }) => {
    const { professionals } = await $query(PROFESSION_TASK_PROFESSIONALS, {
      professionTaskSeoName,
      citySeoName,
      page,
      pageSize,
    });
    return professionals;
  };
}
